export default __webpack_public_path__ + "assets/manufacturer_date.png";